import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import { AppPublic } from "./AppPublic.tsx";
import "./index.css";
import "./styles/marketing.css";
import { logBuildBanner } from "./utils/logBuildBanner.ts";
import { PostHogProvider } from 'posthog-js/react'

const options = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2025-11-30',
} as const

Sentry.init({
  dsn: "https://e50d19ce33c88aa1ab1b55d645aff076@o4510807654072320.ingest.us.sentry.io/4510807655055360",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  // Enable logs to be sent to Sentry
  enableLogs: true
});

logBuildBanner();

createRoot(document.getElementById("root")!).render(<PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} options={options}>
      <AppPublic />
    </PostHogProvider>);
